<template>
    <TopContainer :showAssignmentScore="false">
        <div>
            <div id="resetpassword">
                <img src="./images/registration_image.png" class="register-img"/>

                <form id="ResetPasswordForm" class="resetpassword-form" ref="form" method="POST" novalidate data-vv-scope="resetPassword">
                    <h1>Nieuw wachtwoord invoeren</h1>

                    <div id="ValidationSummary" style="color: red">
                        <ul>
                            <li v-for="error in errors.all()" :key="error.id">{{ error }}</li>
                        </ul>
                    </div>

                    <label for="PasswordTextBox" id="PasswordLabel">Wachtwoord</label>
                    <input id="PasswordTextBox" ref="password" name="Wachtwoord" tabindex="1" type="password" v-validate="'required|min:6'" v-model="form['resetPassword'].password" />

                    <label for="PasswordConfirmationTextBox" style="padding-top: 30px;" id="PasswordConfirmationLabel">Herhaal</label>
                    <input id="PasswordConfirmationTextBox" name="Herhaal wachtwoord" tabindex="2" type="password" v-validate="'confirmed:password'" v-model="form['resetPassword'].passwordConfirmation" />
                </form>
                <div class="buttons">
                    <span style="cursor: pointer;" @click.prevent="onResetPassword(form.resetPassword)" id="ResetButton" class="button_small button_register" tabindex="3">Verander wachtwoord ></span>
                </div>
            </div>
        </div>
    </TopContainer>
</template>

<script>

    import Backend from '../services/Backend';
    import Auth from '../services/Auth';

    //components
    import TopContainer from './TopContainer.vue';

    export default {
        components: {
            TopContainer
        },
        props: ['code'],
        data()
        {
            return {
                'error': null, 
                'message': null,
                'form': {
                    'resetPassword': {
                        username: '',
                        password: '',
                        passwordConfirmation: ''
                    }
                }
            }
        },
        methods: {
            onCancelClick() {
                this.$router.push({ name: 'login'});
            },
            onResetClick() {
                this.$refs.form.submit();
            },
            onResetPassword(form) {
                this.error = null;

                this.$validator.validateAll('resetPassword')
                    .then((r) => {
                        if (!r) return;

                        Backend.resetPassword(this.code, form.password)
                            .done(() =>
                            {
                                this.$router.push({ name: 'login'});
                            })
                            .catch(() =>
                            {
                                this.errors.remove('error');
                                this.errors.add({
                                    field: 'error',
                                    msg: 'Er is iets fout gegaan, probeer het later opnieuw.'
                                });
                            });
                    });
            }
        }
    }
    
</script>
